import { IPermission, IPermissionMap } from '@/shared/types/permission';

const mapping: IPermissionMap[] = [
  {
    permissionId: 1,
    permissionName: 'Data Platform',
    routerName: 'DataPlatform'
  },
  {
    permissionId: 2,
    permissionName: 'Alert Events',
    routerName: 'Alert'
  },
  { permissionId: 3, permissionName: 'CCTV', routerName: 'CCTV' },
  {
    permissionId: 4,
    permissionName: 'Asset List',
    routerName: 'EquipmentAssets'
  },
  {
    permissionId: 5,
    permissionName: 'Inspection Schedule',
    routerName: 'InspectionSchedule'
  },
  {
    permissionId: 6,
    permissionName: 'Inspection Report'
  },
  {
    permissionId: 7,
    permissionName: 'Role Management',
    routerName: 'RolePermission'
  },
  {
    permissionId: 8,
    permissionName: 'User Management',
    routerName: 'UserManagement'
  },
  {
    permissionId: 9,
    permissionName: 'Organization Management',
    routerName: 'OrganizationManagement'
  },
  {
    permissionId: 10,
    permissionName: 'Position Management',
    routerName: 'PositionManagement'
  },
  {
    permissionId: 11,
    permissionName: 'Microservice Management',
    routerName: 'MicroserviceManagement'
  },
  {
    permissionId: 12,
    permissionName: 'Fuxa Config',
    routerName: 'FuxaConfig'
  },
  {
    permissionId: 13,
    permissionName: 'Node-RED Config',
    routerName: 'NodeRedConfig'
  }
];

export const mappingRolePermissions = (
  allPermission: IPermissionMap[],
  rolePermission: IPermission[]
) => {
  const _allPermission = allPermission.map((x) => ({
    ...x,
    canAccess: false,
    canEdit: false
  }));

  rolePermission.forEach((role) => {
    const permission = _allPermission.find(
      (x) => x.permissionId === role.permissionId
    );
    if (permission) {
      permission.canAccess = role.canAccess;
      permission.canEdit = role.canEdit;
    }
  });

  return _allPermission;
};

export default mapping;
